import React from 'react'
import { View, Text, StyleSheet } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  sectionTitleContainer: {
    marginTop: 6,
    marginBottom: 2,
    textAlign: 'center',
  },
  sectionTitle: {
    fontSize: 10,
    fontWeight: 'bold',
  },
  sectionBlack: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#000',
  },
  sectionSubtitle: {
    fontSize: 8,
    color: '#000',
  },
})

interface SectionTitleProps {
  title: string
  subtitle?: string
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ title, subtitle }) => {
  return (
    <View style={styles.sectionTitleContainer}>
      <Text style={styles.sectionTitle}>{title}</Text>
      {subtitle && (
        <Text style={styles.sectionSubtitle}>{subtitle}</Text>
      )}
    </View>
  )
}

